/**
 * Comodidade de hotel no payload do modal — o dado JÁ NORMALIZADO na raiz (o
 * adapter do modal-session), nunca o texto cru do fornecedor.
 *
 * O Apollo devolve `{ id, description }`. O `id` é catálogo estável — 10 hotéis
 * de fornecedores diferentes no develop e uma amostra de produção devolveram o
 * MESMO conjunto (1, 4, 5, 6, 7, 8, 9), sem nenhum id com dois significados.
 *
 * A `description`, essa NÃO é confiável como texto: os mesmos ids voltaram
 * "Academia/Café da manhã/Estacionamento" no develop e "Gym/Breakfast/Parking"
 * em produção. O idioma é decidido em algum lugar do servidor (não por
 * `Accept-Language`, que não muda nada, nem por parâmetro — nenhum dos 211 tipos
 * do subgraph tem campo de idioma), então nem escolhemos nem prevemos. É por
 * isso que o id vira `code` aqui e o front só faz `code → label`.
 *
 * `code` ausente = id fora do catálogo conhecido (2 e 3 nunca apareceram). Aí
 * vale o `label` cru, no idioma que vier: mostrar torto é melhor que sumir com a
 * comodidade.
 */

import { z } from 'zod';

/** Os valores são o sufixo da chave de i18n (`hotel.amenity.<code>`) — o front
 *  monta a chave direto, sem tabela de tradução própria. */
export const HotelAmenityCodeSchema = z.enum([
  'wifi',
  'breakfast',
  'parking',
  'pool',
  'gym',
  'restaurant',
  'laundry',
]);
export type HotelAmenityCode = z.infer<typeof HotelAmenityCodeSchema>;

export const HotelAmenitySchema = z
  .object({
    code: HotelAmenityCodeSchema.optional(),
    label: z.string().trim().min(1),
  })
  .strict();
export type HotelAmenity = z.infer<typeof HotelAmenitySchema>;
